// Purpose: Product type API calls
// Caller: productTypeAction, SyncProductModal, ProductModal
// Dependencies: utils/xhr
// Main Functions: getProductTypes, createProductType, updateProductType, deleteProductType, getProductTypeOptions
// Side Effects: HTTP CRUD /product-type, HTTP GET /product-type/options

import { xhr } from 'utils'

export const getProductTypes = (params = '') => xhr.get(`/product-type?${params}`)
export const createProductType = (data) => xhr.post('/product-type', data)
export const updateProductType = (data, id) => xhr.put(`/product-type/${id}`, data)
export const deleteProductType = (id) => xhr.delete(`/product-type/${id}`)
export const getProductTypeOptions = () => xhr.get('/product-type/options')
